import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found-component',
    templateUrl: './not-found-component.component.html',
    styleUrls: ['./not-found-component.component.scss'],
})
export class NotFoundComponentComponent {}
